let init = function init() {
    Array.prototype.forEach.call(document.querySelectorAll('a[data-linktype="recirculation"]'), function (item) {
        item.addEventListener('click', function (event) {
            event.stopPropagation();
            let dataLayer = window.dataLayer || [];
            let target = event.target;

            dataLayer.push({
                'dL_navHeading': target.getAttribute('data-navheading').toLowerCase().trim(),
                'dL_clickURL': target.getAttribute('href'),
                'dL_clickText': target.text.toLowerCase().trim(),
                'event': 'e_navRecirculation'
            });
        });
    });
};

if (document.readyState === "loading") {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
